module.exports = __webpack_public_path__ + "img/flight-dark-blue.8a65d74b.svg";